exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".apple-badge{text-align:left}.android-badge{text-align:right}.android-badge,.apple-badge{display:block}.android-badge>img,.apple-badge>img{margin-top:12px}@media (max-width:767px){.android-badge,.apple-badge{text-align:center}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules?sourceMap!./assets/css/stores.css
// module id = 714
// module chunks = 0